<template>
  <div class="home">
    <Header />
    <main class="main-content">
      <HeroSection />
      <InnovationSection />
      <SolutionsSection />
      <StatsSection />
      <CustomerStoriesSection />
      <!-- <TeamSection /> -->
      <TestimonialsSection />
      <!-- <NewsSection /> -->
      <ContactSection />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import HeroSection from '../components/HeroSection.vue'
import InnovationSection from '../components/InnovationSection.vue'
import SolutionsSection from '../components/SolutionsSection.vue'
import StatsSection from '../components/StatsSection.vue'
import CustomerStoriesSection from '../components/CustomerStoriesSection.vue'
// import TeamSection from '../components/TeamSection.vue'
import TestimonialsSection from '../components/TestimonialsSection.vue'
// import NewsSection from '../components/NewsSection.vue'
import ContactSection from '../components/ContactSection.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'HomePage',
  components: {
    Header,
    HeroSection,
    InnovationSection,
    SolutionsSection,
    StatsSection,
    CustomerStoriesSection,
    // TeamSection,
    TestimonialsSection,
    // NewsSection,
    ContactSection,
    Footer
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}
</style>
